{
  "loading": "Carregando...",
  "loadingMore": "Carregando mais..."
}